export function getShortestNestedArrayObject(array: any[], nestedArrayName: string) {
  return array.reduce((acc, obj) => {
    if (!acc || obj[nestedArrayName].length < acc[nestedArrayName].length) {
      return obj;
    }
    return acc;
  }, null);
}

export function getCommonElements<T>(array1: T[], array2: T[]): T[] {
  const commonElements: T[] = [];
  for (const element1 of array1) {
    if (array2.includes(element1)) {
      commonElements.push(element1);
    }
  }
  return commonElements;
}

export function hasCommonElement<T>(array1: T[], array2: T[]): boolean {
  for (const element1 of array1) {
    if (array2.includes(element1)) {
      return true; // Found a common element
    }
  }
  return false; // No common elements found
}

export function addObjectIfNotExists(array: any[], newObj: any) {
  // Check if an object with the same key-value pairs exists in the array
  const exists = array.some((obj) => {
    // Compare key-value pairs of newObj and obj
    for (const key in newObj) {
      if (newObj.hasOwnProperty(key) && obj.hasOwnProperty(key)) {
        if (newObj[key] !== obj[key]) {
          return false; // At least one key-value pair doesn't match
        }
      }
    }
    return true; // All key-value pairs match
  });

  // If no matching object was found, add newObj to the array
  if (!exists) {
    array.push(newObj);
  }
}

// Remove undefined elements from object
export function dataObjectWithoutUndefinedFields(obj: any) {
  return Object.fromEntries(Object.entries(obj).filter(([key, value]) => value !== undefined));
}

// Get difference between two arrays
export function getArrayDifference<T>(array1: T[], array2: T[]): T[] {
  return array1.filter((element) => !array2.includes(element));
}

// Check if arrays are different
export function areStringArraysDifferent(arr1: string[], arr2: string[]): boolean {
  // Check if lengths are different
  if (arr1.length !== arr2.length) {
    return true;
  }
  // Sort both arrays and compare each entry
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return true; // Difference found
    }
  }
  // No differences found
  return false;
}

// Seeding
export function hash01(str: string) {
  // tiny stable hash -> [0,1)
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return ((h >>> 0) % 1_000_000) / 1_000_000;
}
